import { spacingHorizontalXS, spacingHorizontalS, spacingHorizontalM, borderRadiusMedium, ButtonStyles } from "@fluentui/web-components";
import { css } from "@microsoft/fast-element";
export const styles = css `
  ${ButtonStyles}

  /* Override Fluent UI small size border-radius to use borderRadiusMedium */
  :host([size="small"]:not([shape="circular"]):not([shape="square"])) {
    border-radius: ${borderRadiusMedium};
  }

  :host([size="small"]) fluent-button {
    gap: ${spacingHorizontalXS};
  }

  fabric-spinner {
    display: none;
  }

  .content {
    gap: ${spacingHorizontalS};
  }

  :host([size="large"]) .content {
    gap: ${spacingHorizontalM};
  }

  :host([loading]) {
    cursor: not-allowed;
  }
  :host([loading]) fabric-spinner {
    display: block;
  }
`;
//# sourceMappingURL=loading-button.styles.js.map